var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-group-create-info",
        centered: "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "footer-class": "flex-nowrap"
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function() {
            return [
              _c("h3", [_vm._v(_vm._s(_vm.$t("modals.infoGroup.title")))])
            ]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-button",
                {
                  staticClass: "p-3",
                  attrs: { variant: "primary", block: "" },
                  on: { click: _vm.closeInfoModal }
                },
                [_vm._v(" " + _vm._s(_vm.$t("buttons.ok")) + " ")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "div",
        { staticClass: "show-url-icon text-center px-3" },
        [
          _c("b-icon", {
            staticClass: "mt-3 mb-2",
            attrs: { icon: "exclamation-triangle", variant: "info" }
          }),
          _c("div", {
            staticClass: "mt-2 mb-4 mx-4",
            domProps: { innerHTML: _vm._s(_vm.$t("modals.infoGroup.text")) }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }